import { render, staticRenderFns } from "./StarsRate.vue?vue&type=template&id=7b174210&"
import script from "./StarsRate.vue?vue&type=script&lang=js&"
export * from "./StarsRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports